export interface Movie {
  id: string;
  title: string;
  en: string;
  genres: string[];
  year: number;
  rating: number;
  duration: number;
  region: string;
  director: string;
  cast: string[];
  tagline: string;
  summary: string;
  poster: string;
  popularity: number;
  isTodayUpdate: boolean;
  isNewRelease: boolean;
  isCinemaSync: boolean;
  isUpcoming: boolean;
  releaseDate: string;
}

export const movies: Movie[] = [
  {
    id: 'mv-01',
    title: '星海回声',
    en: 'Echoes of the Star Sea',
    genres: ['科幻', '冒险'],
    year: 2024,
    rating: 8.7,
    duration: 138,
    region: '中国大陆',
    director: '林望川',
    cast: ['周砚', '苏黎', '贺行'],
    tagline: '当故乡的信号迟到二十年，你还愿意回应吗？',
    summary: '一名深空探测员在一颗沉默星球上收到来自家乡的迟到信号，为了确认信号背后的真相，他独自踏上一段横跨星海的返程。影片以克制的对白与辽阔的视觉，讨论孤独、记忆与归属。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20silhouetted%20astronaut%20standing%20before%20a%20colossal%20glowing%20ringed%20planet%2C%20deep%20space%20nebula%20background%2C%20dramatic%20rim%20lighting%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20vertical%20composition%2C%20film%20grain%2C%20highly%20detailed%2C%20no%20text&width=600&height=900&seq=mv-01&orientation=portrait',
    popularity: 98,
    isTodayUpdate: true,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-09-18',
  },
  {
    id: 'mv-02',
    title: '长夜将尽',
    en: 'Before the Long Night Ends',
    genres: ['犯罪', '悬疑'],
    year: 2024,
    rating: 8.3,
    duration: 126,
    region: '中国大陆',
    director: '高树声',
    cast: ['严牧', '柯雨', '郭延'],
    tagline: '每一条线索，都指向同一场雪。',
    summary: '边境小城在一个冬天连续发生数起无法解释的案件，一位即将退休的刑警与年轻的档案员联手梳理十年旧卷，试图在长夜结束前拼出被掩盖的轮廓。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%2C%20lone%20detective%20in%20a%20heavy%20coat%20under%20a%20single%20streetlamp%20in%20falling%20snow%2C%20narrow%20alley%20at%20night%2C%20cold%20grey%20and%20warm%20amber%20highlights%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-02&orientation=portrait',
    popularity: 92,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: true,
    isUpcoming: false,
    releaseDate: '2024-07-05',
  },
  {
    id: 'mv-03',
    title: '沙城迷雾',
    en: 'Mist Over the Sand City',
    genres: ['悬疑', '冒险'],
    year: 2024,
    rating: 7.9,
    duration: 118,
    region: '中国大陆',
    director: '聂青',
    cast: ['沈舟', '白柠'],
    tagline: '被风掩埋的不只是城，还有名字。',
    summary: '一支考古队在沙漠古城遗址中发现了数十年前留下的日记，随着发掘深入，队员们逐渐发现这场考察与自己的家族历史交织在一起，迷雾既是天气，也是人心。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20movie%20poster%20of%20a%20desert%20ruin%20city%20emerging%20from%20swirling%20sand%20mist%2C%20lone%20figure%20in%20a%20long%20coat%20walking%20toward%20it%2C%20golden%20dust%20light%2C%20warm%20ochre%20tones%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-03&orientation=portrait',
    popularity: 84,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-06-21',
  },
  {
    id: 'mv-04',
    title: '逆光而行',
    en: 'Against the Light',
    genres: ['剧情'],
    year: 2024,
    rating: 8.1,
    duration: 112,
    region: '中国大陆',
    director: '余晚',
    cast: ['江迟', '温言'],
    tagline: '总有人要在没人看的地方继续走。',
    summary: '一名地方记者持续追访一场几乎无人报道的迁徙，从最初的记录者，慢慢变成参与者。影片用纪实的镜头语言，呈现普通人如何在逆光中保持方向。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%2C%20lone%20traveler%20walking%20along%20an%20empty%20country%20road%20at%20golden%20hour%2C%20strong%20backlight%20and%20long%20shadow%2C%20warm%20sunlit%20tones%2C%20minimal%20composition%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-04&orientation=portrait',
    popularity: 80,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-05-17',
  },
  {
    id: 'mv-05',
    title: '浮生七日',
    en: 'Seven Days of a Floating Life',
    genres: ['爱情', '剧情'],
    year: 2024,
    rating: 7.6,
    duration: 104,
    region: '中国大陆',
    director: '许知白',
    cast: ['林澈', '宋知'],
    tagline: '有些相遇，只够七天。',
    summary: '两段原本平行的人生因一场航班延误在海边小城短暂交汇，他们约定用七天把想说却来不及说的话讲完。影片节奏舒缓，注重情绪与细节的描摹。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%2C%20two%20distant%20figures%20on%20a%20quiet%20seaside%20pier%20at%20sunset%2C%20soft%20pastel%20warm%20tones%2C%20gentle%20bokeh%20lights%2C%20dreamy%20atmosphere%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-05&orientation=portrait',
    popularity: 72,
    isTodayUpdate: false,
    isNewRelease: true,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-08-30',
  },
  {
    id: 'mv-06',
    title: '铁轨上的夏天',
    en: 'Summer on the Rails',
    genres: ['剧情', '青春'],
    year: 2024,
    rating: 8.0,
    duration: 116,
    region: '中国大陆',
    director: '程野',
    cast: ['孟宇', '何苗'],
    tagline: '那条铁路上，埋着我们的十七岁。',
    summary: '一条即将拆除的废弃铁路串联起三个少年的成长记忆。多年后他们各自回到小城，沿着铁轨重走一遍当年走过的路，也重新面对当年的选择。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20coming%20of%20age%20movie%20poster%2C%20teenagers%20cycling%20beside%20abandoned%20railway%20tracks%20in%20lush%20summer%20fields%2C%20golden%20warm%20sunlight%2C%20nostalgic%20warm%20tones%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-06&orientation=portrait',
    popularity: 76,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-04-12',
  },
  {
    id: 'mv-07',
    title: '无声警戒',
    en: 'Silent Alert',
    genres: ['动作', '犯罪'],
    year: 2024,
    rating: 7.8,
    duration: 130,
    region: '中国大陆',
    director: '韩慕',
    cast: ['陆沉', '纪北', '游川'],
    tagline: '信号中断之后，只剩本能。',
    summary: '一支特勤小队被派往信号盲区执行护送任务，通讯中断、路线被封，他们必须在完全失去支援的情况下判断谁是同伴、谁是威胁。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20movie%20poster%2C%20tactical%20operative%20silhouette%20in%20a%20dark%20corridor%20with%20emergency%20red%20lighting%2C%20smoke%20and%20sparks%2C%20high%20contrast%2C%20dramatic%20warm%20red%20tones%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-07&orientation=portrait',
    popularity: 88,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: true,
    isUpcoming: false,
    releaseDate: '2024-08-02',
  },
  {
    id: 'mv-08',
    title: '时光邮局',
    en: 'The Time Post Office',
    genres: ['奇幻', '剧情'],
    year: 2024,
    rating: 8.4,
    duration: 121,
    region: '中国大陆',
    director: '安栖',
    cast: ['顾南', '叶知秋'],
    tagline: '这里的信，只寄给过去的人。',
    summary: '小镇上一家老旧邮局能让信件寄往过去，新来的营业员在一次投递中改变了别人的一生，也终于读懂了母亲留在柜台下的那封信。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20poster%2C%20cozy%20old%20post%20office%20interior%20with%20glowing%20golden%20mailboxes%20and%20floating%20envelopes%2C%20warm%20amber%20lamplight%2C%20magical%20dust%20motes%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-08&orientation=portrait',
    popularity: 90,
    isTodayUpdate: true,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-09-06',
  },
  {
    id: 'mv-09',
    title: '荒野信使',
    en: 'The Wilderness Courier',
    genres: ['冒险', '剧情'],
    year: 2024,
    rating: 7.7,
    duration: 109,
    region: '中国大陆',
    director: '穆远',
    cast: ['谢屿', '安宁'],
    tagline: '一封信，要穿过整片风暴带。',
    summary: '年轻信使受人之托，穿越风暴频发的高原荒原送出一封写有重要约定的信。沿途的陌生人、坏掉的车与反复的风，构成了这趟旅程的全部重量。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20movie%20poster%2C%20lone%20courier%20walking%20through%20a%20vast%20stormy%20highland%20plain%20with%20dark%20clouds%2C%20small%20figure%20against%20huge%20landscape%2C%20moody%20warm%20and%20charcoal%20tones%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-09&orientation=portrait',
    popularity: 70,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-03-15',
  },
  {
    id: 'mv-10',
    title: '第七码头的女儿',
    en: 'Daughter of Pier Seven',
    genres: ['剧情', '家庭'],
    year: 2024,
    rating: 8.2,
    duration: 133,
    region: '中国大陆',
    director: '谭守',
    cast: ['文昭', '陈汐', '贺行'],
    tagline: '港口会变，姓氏不会。',
    summary: '一个港口家族迎来第三代掌门人的交接，女儿试图用新的方式留住父辈用一辈子守下来的码头。影片在时代变迁与家庭羁绊之间寻找平衡。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20movie%20poster%2C%20young%20woman%20standing%20on%20an%20old%20harbor%20pier%20at%20dusk%2C%20cargo%20cranes%20and%20fishing%20boats%20silhouetted%2C%20warm%20orange%20and%20deep%20grey%20tones%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-10&orientation=portrait',
    popularity: 78,
    isTodayUpdate: false,
    isNewRelease: false,
    isCinemaSync: true,
    isUpcoming: false,
    releaseDate: '2024-06-07',
  },
  {
    id: 'mv-11',
    title: '山海秘钥',
    en: 'The Mountain and Sea Key',
    genres: ['奇幻', '冒险'],
    year: 2024,
    rating: 7.5,
    duration: 145,
    region: '中国大陆',
    director: '祝青野',
    cast: ['骆舟', '易星', '白柠'],
    tagline: '地图的尽头，是一把钥匙。',
    summary: '一群来自不同地方的寻宝者为了解开一张古老地图踏上旅程，山海之间的传说与现实的利益不断冲撞，他们渐渐发现真正要找的东西并不在终点。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20adventure%20movie%20poster%2C%20ancient%20glowing%20ornate%20key%20floating%20above%20misty%20mythical%20mountains%20and%20sea%2C%20dramatic%20warm%20gold%20light%2C%20epic%20scale%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-11&orientation=portrait',
    popularity: 83,
    isTodayUpdate: false,
    isNewRelease: true,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-09-28',
  },
  {
    id: 'mv-12',
    title: '城南旧梦',
    en: 'Old Dreams of the South City',
    genres: ['剧情'],
    year: 2024,
    rating: 8.5,
    duration: 125,
    region: '中国大陆',
    director: '沈岐',
    cast: ['温言', '江迟', '孟宇'],
    tagline: '拆掉的是房子，留下的是人。',
    summary: '老街拆迁前的最后一个冬天，几户老邻居在短暂的相处中重新认识彼此。影片用四季变化般的节拍，讲述城市更新里被轻轻放下的人情。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%2C%20old%20city%20alleyway%20in%20winter%20dusk%20with%20warm%20lit%20windows%2C%20lone%20figure%20walking%20through%20light%20snow%2C%20nostalgic%20warm%20and%20muted%20tones%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=mv-12&orientation=portrait',
    popularity: 86,
    isTodayUpdate: true,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-09-20',
  },
  {
    id: 'mv-13',
    title: '幽蓝深海',
    en: 'The Deep Blue Silence',
    genres: ['科幻', '惊悚'],
    year: 2024,
    rating: 7.9,
    duration: 128,
    region: '中国大陆',
    director: '冷杉',
    cast: ['纪北', '苏黎'],
    tagline: '海面之下，没有人能听到你的呼叫。',
    summary: '深海科考站在一次例行作业后与地面失去联系，救援队下潜后发现站内的记录与事实存在明显出入。影片以幽闭空间营造持续的紧张感。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20thriller%20movie%20poster%2C%20deep%20sea%20research%20station%20module%20lit%20by%20small%20warm%20lights%20in%20dark%20ocean%2C%20lone%20diver%20silhouette%2C%20eerie%20atmosphere%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-13&orientation=portrait',
    popularity: 81,
    isTodayUpdate: true,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-10-04',
  },
  {
    id: 'mv-14',
    title: '末日花园',
    en: 'The Last Garden',
    genres: ['科幻', '剧情'],
    year: 2024,
    rating: 8.0,
    duration: 137,
    region: '中国大陆',
    director: '柳岸',
    cast: ['周砚', '叶知秋', '游川'],
    tagline: '只要还有一粒种子，就还没结束。',
    summary: '在资源几近枯竭的世界里，最后一座温室保存着仅存的植物样本。园丁们为一粒能否发芽的种子争论不休，也在这场争论里重新定义了希望。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20last%20greenhouse%20geodesic%20dome%20glowing%20with%20warm%20light%20in%20a%20barren%20grey%20landscape%2C%20lone%20gardener%20figure%2C%20hopeful%20warm%20tones%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-14&orientation=portrait',
    popularity: 82,
    isTodayUpdate: false,
    isNewRelease: true,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-10-11',
  },
  {
    id: 'mv-15',
    title: '追风少年',
    en: 'The Boy Who Chased the Wind',
    genres: ['动画', '家庭'],
    year: 2024,
    rating: 8.6,
    duration: 98,
    region: '中国大陆',
    director: '殷禾',
    cast: ['配音｜易星', '配音｜何苗'],
    tagline: '风会记得每一个追它的人。',
    summary: '出生在海边小镇的少年为了兑现与爷爷的约定，造出一架属于自己的滑翔机。手绘质感的画面与轻快的配乐，让这趟追风之旅温和又明亮。',
    poster: 'https://readdy.ai/api/search-image?query=animated%20family%20movie%20poster%2C%20hand%20drawn%20boy%20running%20with%20a%20colorful%20kite%20on%20a%20sunny%20green%20hill%20by%20the%20sea%2C%20warm%20painterly%20tones%2C%20whimsical%20style%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-15&orientation=portrait',
    popularity: 89,
    isTodayUpdate: true,
    isNewRelease: false,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-09-14',
  },
  {
    id: 'mv-16',
    title: '雪落长安',
    en: 'Snowfall Over Chang’an',
    genres: ['古装', '剧情'],
    year: 2024,
    rating: 8.1,
    duration: 142,
    region: '中国大陆',
    director: '裴斯年',
    cast: ['骆舟', '文昭', '孟宇'],
    tagline: '一场大雪，盖住了长安，也盖住了旧事。',
    summary: '大雪封城的长安城中，一名负责修缮宫墙的匠人意外卷入一桩旧案。影片以考究的服化道与克制的叙事，还原一座古城的冬日光影。',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20movie%20poster%2C%20ancient%20Chinese%20city%20under%20heavy%20snow%20at%20dusk%2C%20temple%20roofs%20and%20lanterns%20glowing%20warm%20orange%2C%20lone%20figure%20in%20traditional%20robe%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=mv-16&orientation=portrait',
    popularity: 85,
    isTodayUpdate: false,
    isNewRelease: true,
    isCinemaSync: false,
    isUpcoming: false,
    releaseDate: '2024-10-18',
  },
];

export const allGenres = ['科幻', '悬疑', '犯罪', '动作', '剧情', '爱情', '青春', '奇幻', '冒险', '惊悚', '家庭', '动画', '古装'];